export const insuranceRatesSerializeMap = {
  insuranceType: "insurance_type",
  standardRate: "standard_rate",
  extendedRate: "extended_rate",
  providerStandardRate: "provider_standard_rate",
  providerExtendedRate: "provider_extended_rate",
};
